import type { RequiredTargetingFormType } from '@openx/types/targeting/targetingPresets.ts';
import { CursorClickIcon } from '@phosphor-icons/react/CursorClick';
import { ScreencastIcon } from '@phosphor-icons/react/Screencast';
import { SubtitlesIcon } from '@phosphor-icons/react/Subtitles';
import { VideoIcon } from '@phosphor-icons/react/Video';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type Section, TargetingElementKeys, type TargetingElementKeysType } from '../../context/types.ts';
import { convertApiToSet } from '../../utils/convertApiToSet.ts';

export const useReadOnlyFormatInitialState = (
  targetingParams: RequiredTargetingFormType | null | undefined
): Section => {
  const { t } = useTranslation();

  return useMemo(() => {
    const formValue = targetingParams?.ad_placement.val;
    const initValues = convertApiToSet(formValue);
    const isSelected = (key: TargetingElementKeysType): boolean => initValues.has(key);

    return {
      label: t('Format'),
      isLoading: true,
      elements: [
        {
          mainOption: {
            key: TargetingElementKeys.FORMAT_BANNER,
            label: t('Banner'),
            icon: <SubtitlesIcon size={24} />,
            isSelected: isSelected(TargetingElementKeys.FORMAT_BANNER),
            isDisabled: true,
          },
        },
        {
          mainOption: {
            key: TargetingElementKeys.FORMAT_VIDEO,
            label: t('Video'),
            icon: <VideoIcon size={24} />,
            isSelected: isSelected(TargetingElementKeys.FORMAT_VIDEO),
            isDisabled: true,
          },
        },
        {
          mainOption: {
            key: TargetingElementKeys.FORMAT_CTV,
            label: t('CTV'),
            icon: <ScreencastIcon size={24} />,
            isSelected: isSelected(TargetingElementKeys.FORMAT_CTV),
            isDisabled: true,
          },
        },
        {
          mainOption: {
            key: TargetingElementKeys.FORMAT_NATIVE,
            label: t('Native'),
            icon: <CursorClickIcon size={24} />,
            isSelected: isSelected(TargetingElementKeys.FORMAT_NATIVE),
            isDisabled: true,
          },
        },
      ],
    };
  }, [t, targetingParams]);
};
